export default __webpack_public_path__ + "7f4e9a53a4db1b55f9a86f9211ad31e6.svg";